export default __webpack_public_path__ + "static/media/Selma_9781408355046.b594acbf.jpg";